import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import axiosPrivate from "../../services/axios/axiosPrivate";

export const updateCandidateStatus = createAsyncThunk('candidate/updateCandidateStatus',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosPrivate.post(api.updateCandidateStatus, payload);
      return response.data;
    } catch(error) {
      return rejectWithValue(error?.response?.data?.message || "Unable to connect to server");
    }
  })

const updateCandidateStatusSlice = createSlice({
  name: 'candidateStatus',
  initialState: {
    candidateStatus: [],
    status: 'idle',
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builders) => {
    builders
      .addCase(updateCandidateStatus.pending,
        (state) => {
          state.status = 'loading';
          state.loading = true;
          state.error = null;
        })
      .addCase(updateCandidateStatus.fulfilled,
        (state, action) => {
          state.status = 'succeeded';
          state.loading = false;
          state.candidateStatus = action.payload;
        })
      .addCase(updateCandidateStatus.rejected,
        (state, action) => {
          state.status = 'failed';
          state.loading = false;
          state.error = action.payload;
        }
      )
  }
})

export default updateCandidateStatusSlice.reducer;